export const techReadiGoMode = 'tech_redi_go_mode';
export const techReadiGoModeOsslt = 'tech_redi_go_mode_osslt';
export const boardTechReadinessCheck = 'tech_redi_school_board_check';
export const boardTechReadinessCheckOsslt = 'tech_redi_school_board_check_osslt';
